import * as React from 'react';
import { Button } from 'baseui/button';
import { ChevronDown } from 'baseui/icon';
import { StatefulPopover, PLACEMENT } from 'baseui/popover';
import { StatefulMenu } from 'baseui/menu';


export default function DropdownButton(props) {
  return (
    <StatefulPopover
      focusLock
      placement={PLACEMENT.bottomLeft}
      content={({ close }) => (
        <StatefulMenu
          items={props.items}
          onItemSelect={(item) => {
            // Call the action associated with the item
            item.item.action();
            close();
          }}
          overrides={{
            List: { style: { height: '130px', width: '138px' } },
          }}
        />
      )}
    >
      <Button
        size='compact'
       endEnhancer={() => <ChevronDown size={24} />}>
        Add Parameter
      </Button>
    </StatefulPopover>
  );
}
